import {
  Component,
  effect,
  ElementRef,
  inject,
  signal,
  viewChild,
  AfterViewInit,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { svgIconKeys } from '../../../constants/svg-icon-keys';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthStore } from '../../store/authentication/auth.store';
import {
  LocalStorageKeys,
  LocalStorageService,
} from '../../services/local-storage.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'blindspot-show-impersonation',
  styleUrls: ['./show-impersonation.component.scss'],
  imports: [
    SvgIconComponent,
    ToastModule,
    ProgressSpinnerModule,
    SvgIconComponent,
    TooltipModule,
  ],
  template: `
    @if (authStore.loggedInUser()?.impersonatedBy) {
      <div class="impersonation">
        <svg-icon class="svg" svgClass="icon" [src]="svgIconKeys.impersonate" />
        <div class="user">
          <div
            class="value"
            #value
            [pTooltip]="authStore.loggedInUser()?.email"
            tooltipPosition="top"
            [tooltipDisabled]="tooltipDisabled()"
          >
            {{ authStore.loggedInUser()?.email }}
          </div>
        </div>
        <div class="stop" (click)="stopImpersonation()">
          <svg-icon class="svg" svgClass="icon" [src]="svgIconKeys.close" />
        </div>
      </div>
    }
  `,
})
export class ShowImpersonationComponent {
  public authStore = inject(AuthStore);
  public valueElement = viewChild<ElementRef<HTMLDivElement>>('value');
  public tooltipDisabled = signal(false);

  constructor() {
    effect(() => {
      const valueElement = this.valueElement();
      if (valueElement) {
        this.tooltipDisabled.set(
          // +1 to account for browser rounding error when truncating text
          valueElement.nativeElement.clientWidth + 1 >=
            valueElement.nativeElement.scrollWidth,
        );
      }
    });
  }

  public stopImpersonation(): void {
    LocalStorageService.remove(LocalStorageKeys.IMPERSONATION_TOKEN);
    window.location.reload();
  }

  protected readonly svgIconKeys = svgIconKeys;
}
